import { FC } from "react";
import { Menu, MenuButton, MenuList, MenuItem, Button } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useComponentAccess, useTeamInvites, useToastNotification } from "lib/hooks";
import { PermissionLevels, TeamInvite, TeamPermissions } from "lib/types";
import { teamInvitesClient } from "lib/clients";

type Props = {
  invite: TeamInvite;
}

export const InviteListingItemMenu: FC<Props> = ({ invite }) => {
  const { successToast, errorToast } = useToastNotification();
  const { hasAccess } = useComponentAccess([PermissionLevels.ADMIN, PermissionLevels.OWNER]);
  const { mutate } = useTeamInvites();

  if (!hasAccess) {
    return <Button isDisabled={true} width={100} size="sm">{invite.permissions}</Button>
  }

  const handleUpdate = async (permissions: TeamPermissions) => {
    if (permissions === invite.permissions) {
      return;
    }

    try {
      await teamInvitesClient.putInvite({ ...invite, permissions });
      await mutate();
      successToast({ title: 'Success', description: `Permissions changed for ${invite.match}` });
    } catch (err) {
      errorToast({ title: 'Error', description: err })
    }
  }

  const handleDelete = async () => {
    try {
      await teamInvitesClient.deleteInvite(invite.id);
      await mutate();
      successToast({ title: 'Success', description: `Invite removed for ${invite.match}` });
    } catch (err) {
      errorToast({ title: 'Error', description: err })
    }
  }

  return (
    <Menu>
      <MenuButton variant="secondary" as={Button} rightIcon={<ChevronDownIcon />} width={100} size="sm">
        {invite.permissions}
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => handleUpdate(TeamPermissions.ADMIN)}>Admin</MenuItem>
        <MenuItem onClick={() => handleUpdate(TeamPermissions.MEMBER)}>Member</MenuItem>
        <MenuItem onClick={handleDelete} color="error.500">Remove invite</MenuItem>
      </MenuList>
    </Menu>
  );
}
